/**
 * Parses a prompt version timestamp (YYMMDDHHmmss) into a Date object
 * @param version The prompt version timestamp string
 * @returns Date object or null if format is invalid
 */
export function parsePromptVersionDate(version: string): Date | null {
  if (/^\d{12}$/.test(version)) {
    try {
      const year = parseInt(version.substring(0, 2)) + 2000;
      const month = parseInt(version.substring(2, 4)) - 1; // JS months are 0-indexed
      const day = parseInt(version.substring(4, 6));
      const hour = parseInt(version.substring(6, 8));
      const minute = parseInt(version.substring(8, 10));

      const date = new Date(year, month, day, hour, minute);

      if (isNaN(date.getTime())) return null;

      return date;
    } catch {
      return null;
    }
  }

  return null;
}
